/* globals ga */
/* globals yaCounter26190288 */
/**
 * Yandex Google Analytics
 * @param data
 */
let addAnalyticsForm = (data) => {
    if (data === null || typeof data === 'object' && Object.keys(data).length === 0) {
        return;
    }

    if (typeof ga !== 'undefined') {
        const {analytics = {}} = data;

        if (Object.prototype.hasOwnProperty.call(analytics, 'event') &&
            Object.prototype.hasOwnProperty.call(analytics, 'category') &&
            Object.prototype.hasOwnProperty.call(analytics, 'action') &&
            Object.prototype.hasOwnProperty.call(analytics, 'label')
        ) {
            window.dataLayer = window.dataLayer || [];
            const {event, category, action, label} = analytics;

            window.dataLayer.push({
                event,
                eventCategory: category,
                eventAction: action,
                eventLabel: label,
            });
        }
    }
};

export default addAnalyticsForm;
